import _ from 'lodash';

import AgentRead from 'models/agent_read';
import DocumentStoreSaveResultHandler from '../lib/document_store_save_result_handler';
import DtoConverter from 'scripts/application/dto_converters/agent_read_converter';
import { getLatestConversationId } from 'actions/conversation/lib/conversation_helpers';
import mixin from 'scripts/lib/mixin';

export default class AgentReadGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onFetchSuccess(agentReadDto) {
    const newRead = DtoConverter.fromDto(agentReadDto);

    const customerId = this.findCustomerForConversationId(newRead.conversationId);
    if (customerId) {
      this.context.stores.customers.storesFor(customerId).agentRead.resetLoading();
      // Updates are sent to the backend on a throttle, so a fetch can return a read older than the one we have.
      this.replaceCustomerRead(customerId, newRead);
    }
    this.updateActiveSession(newRead);
  }

  onFetchError(errorDto) {
    throw new Error(`Failed to fetch agent read: ${JSON.stringify(errorDto)}`);
  }

  onBroadcast(agentReadDto) {
    const newRead = DtoConverter.fromDto(agentReadDto);

    const customerId = this.findCustomerForConversationId(newRead.conversationId);
    if (customerId) {
      this.replaceCustomerRead(customerId, newRead);
    }
    this.updateActiveSession(newRead);
  }

  replaceCustomerRead(customerId, newRead) {
    const customerStores = this.context.stores.customers.storesFor(customerId);
    if (newRead.shouldReplace(customerStores.agentRead.get(), getLatestConversationId(customerStores.conversations))) {
      customerStores.agentRead.set(newRead);
    }
  }

  onReplaceSuccess() {}

  onReplaceError(errorDto) {
    throw new Error(`Failed to update agent read: ${JSON.stringify(errorDto)}`);
  }

  _isConversationForCurrentCustomer(conversationId) {
    const customerId = _.get(this.context.stores.currentLocation.get(), 'customerId');
    if (!customerId || !this.context.stores.customers.has({ id: customerId })) {
      return false;
    }

    const conversation = this.context.stores.customers
      .storesFor(customerId)
      .conversations.findBy({ id: conversationId });
    if (!conversation) {
      return false;
    }

    return true;
  }

  findCustomerForConversationId(conversationId) {
    let foundCustomerId;
    this.context.stores.customers.findAll({ select: ['id'] }).map(customer => {
      const conversation = this.context.stores.customers
        .storesFor(customer.id)
        .conversations.findBy({ id: conversationId });
      if (conversation) {
        foundCustomerId = customer.id;
      }
    });
    return foundCustomerId;
  }

  updateActiveSession(agentRead) {
    const activeSession = this.context.stores.activeSessions.findBy({
      queueItem: { conversationId: agentRead.conversationId },
    });
    if (activeSession && !AgentRead.isReadToAtLeast(activeSession.readTo, agentRead.readTo)) {
      activeSession.update({ readTo: agentRead.readTo });
      this.context.stores.activeSessions.replace(activeSession);
    }
  }
}

mixin(AgentReadGatewayObserver.prototype, DocumentStoreSaveResultHandler.prototype);
